import script from "./RecordDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordDetails.vue?vue&type=script&setup=true&lang=js"

import "./RecordDetails.vue?vue&type=style&index=0&id=189b3013&lang=css"

const __exports__ = script;

export default __exports__